import React from 'react';
import { User } from 'lucide-react';

const TheaterSeats = ({ participants = [] }) => {
    const totalSeats = 20;

    const getInitials = (username) => {
        if (!username) return '?';
        const parts = username.split(' ');
        if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
        return username.slice(0, 2).toUpperCase();
    };

    const seats = Array(totalSeats).fill(null).map((_, index) =>
        index < participants.length ? participants[index] : null
    );

    return (
        <div style={{ position: 'relative' }}>
            {/* Seats */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8, padding: '0 16px', flexWrap: 'wrap' }}>
                {seats.map((participant, index) => (
                    <div
                        key={index}
                        style={{
                            position: 'relative',
                            transform: 'perspective(500px) rotateX(25deg)',
                            transformOrigin: 'bottom',
                        }}
                        className="group"
                    >
                        {/* Seat body */}
                        <div style={{
                            width: 36, height: 44,
                            borderRadius: '8px 8px 0 0',
                            border: '2px solid',
                            transition: 'all 150ms ease',
                            background: participant
                                ? 'linear-gradient(to bottom, var(--accent), #9C742F)'
                                : 'linear-gradient(to bottom, #7F1D1D, #450A0A)',
                            borderColor: participant
                                ? 'rgba(232,183,90,0.5)'
                                : 'rgba(185,28,28,0.4)',
                            opacity: participant ? 1 : 0.3,
                        }}>
                            {participant && (
                                <div style={{
                                    position: 'absolute',
                                    top: -36, left: '50%',
                                    transform: 'translateX(-50%)',
                                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                                    pointerEvents: 'none',
                                }}>
                                    {/* Avatar */}
                                    <div style={{
                                        width: 28, height: 28,
                                        borderRadius: '50%',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#fff', fontSize: '0.6875rem', fontWeight: 700,
                                        border: '2px solid rgba(255,255,255,0.2)',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
                                        backgroundColor: participant.color || 'var(--accent)',
                                        transform: 'perspective(500px) rotateX(-25deg)',
                                    }}>
                                        {getInitials(participant.username)}
                                    </div>

                                    {/* Name tooltip desktop */}
                                    <div
                                        className="hidden sm:block"
                                        style={{
                                            position: 'absolute',
                                            top: -32, left: '50%', transform: 'translateX(-50%)',
                                            background: 'rgba(0,0,0,0.85)',
                                            backdropFilter: 'blur(8px)',
                                            color: '#fff',
                                            fontSize: '0.6875rem',
                                            padding: '3px 8px',
                                            borderRadius: 6,
                                            whiteSpace: 'nowrap',
                                            opacity: 0,
                                            transition: 'opacity 150ms ease',
                                            pointerEvents: 'none',
                                        }}
                                    >
                                        {participant.username}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Name visible on mobile */}
                        {participant && (
                            <div
                                className="sm:hidden"
                                style={{
                                    position: 'absolute', top: -40, left: '50%',
                                    transform: 'translateX(-50%)',
                                    color: '#fff', fontSize: '0.5rem',
                                    whiteSpace: 'nowrap',
                                    background: 'rgba(0,0,0,0.6)',
                                    padding: '1px 4px',
                                    borderRadius: 4,
                                    pointerEvents: 'none',
                                }}
                            >
                                {participant.username.length > 8
                                    ? participant.username.slice(0, 8) + '...'
                                    : participant.username
                                }
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Legend */}
            <div style={{ textAlign: 'center', marginTop: 28 }}>
                <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: 10,
                    background: 'linear-gradient(135deg, rgba(232,183,90,0.15), rgba(156,116,47,0.1))',
                    border: '1px solid rgba(232,183,90,0.25)',
                    borderRadius: 'var(--r-xl)',
                    padding: '10px 20px',
                    backdropFilter: 'blur(8px)',
                    boxShadow: '0 4px 16px rgba(232,183,90,0.12)',
                }}>
                    <div style={{
                        width: 32, height: 32,
                        borderRadius: '50%',
                        background: 'rgba(232,183,90,0.25)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <User style={{ width: 16, height: 16, color: 'var(--accent-bright)' }} />
                    </div>
                    <span style={{ color: 'var(--text-1)', fontWeight: 500, fontSize: '0.9375rem' }}>
                        {participants.length} {participants.length > 1 ? 'spectateurs' : 'spectateur'}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default TheaterSeats;
